export const OperationWorkOrderCenterRouting = [
  {
    path: "/maintenance/operationWorkOrderCenter",
    name: "maintenance-operationWorkOrderCenter-list",
    meta: { title: "运维工单中心" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operationWorkOrderCenter" */ "@/views/maintenance/operationWorkOrderCenter/list/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/operationWorkOrderCenter/create",
    name: "maintenance-operationWorkOrderCenter-create",
    meta: { title: "新建运维工单", comName: "OperationWorkOrderCenterFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operationWorkOrderCenter" */ "@/views/maintenance/operationWorkOrderCenter/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/operationWorkOrderCenter/edit/:id",
    name: "maintenance-operationWorkOrderCenter-edit",
    meta: { title: "编辑运维工单", comName: "OperationWorkOrderCenterFormCreate" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operationWorkOrderCenter" */ "@/views/maintenance/operationWorkOrderCenter/form-create/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/operationWorkOrderCenter/detail/:id",
    name: "maintenance-operationWorkOrderCenter-detail",
    meta: { title: "运维工单详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operationWorkOrderCenter" */ "@/views/maintenance/operationWorkOrderCenter/form-detail/index.vue"
      ),
  },
  {
    hidden: true,
    path: "/maintenance/operationWorkOrderCenter/flowPrint/:id",
    name: "maintenance-operationWorkOrderCenter-flow-print",
    meta: { title: "运维工单打印详情" },
    component: () =>
      import(
        /* webpackChunkName: "maintenance-operationWorkOrderCenter" */ "@/views/maintenance/operationWorkOrderCenter/flow-print/index.vue"
      ),
  },
];
